/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsReferences,
    MelcoModelsReferencesFromJSON,
    MelcoModelsReferencesFromJSONTyped,
    MelcoModelsReferencesToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoFusionModelsBlankReferences
 */
export interface MelcoFusionModelsBlankReferences {
    /**
     * 
     * @type {Array<MelcoModelsReferences>}
     * @memberof MelcoFusionModelsBlankReferences
     */
    custom_product_list?: Array<MelcoModelsReferences> | null;
}

export function MelcoFusionModelsBlankReferencesFromJSON(json: any): MelcoFusionModelsBlankReferences {
    return MelcoFusionModelsBlankReferencesFromJSONTyped(json, false);
}

export function MelcoFusionModelsBlankReferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsBlankReferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'custom_product_list': !exists(json, 'custom_product_list') ? undefined : (json['custom_product_list'] === null ? null : (json['custom_product_list'] as Array<any>).map(MelcoModelsReferencesFromJSON)),
    };
}

export function MelcoFusionModelsBlankReferencesToJSON(value?: MelcoFusionModelsBlankReferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'custom_product_list': value.custom_product_list === undefined ? undefined : (value.custom_product_list === null ? null : (value.custom_product_list as Array<any>).map(MelcoModelsReferencesToJSON)),
    };
}


